export default "HOTEL_DESKTOP";
